import { configure } from "mobx"
import { Provider, enableStaticRendering } from "mobx-react"

import cartStore from "./cartStore"

enableStaticRendering(typeof window === "undefined")

configure({
    enforceActions: "never",
})

const stores = {
    cartStore,
}
export type StoreContext = typeof stores
export function StoresProvider({ children }) {
    return <Provider {...stores}>{children}</Provider>
}
